import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./app.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./app.component.scss?ngResource";
import { APP_BASE_HREF, LocationStrategy } from "@angular/common";
import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { AuthService } from "./shared/services/auth/auth.service";
import { LoginService } from "./shared/services/login/login.service";
import { AppControllerService } from "./app-controller.service";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { UserInformationService } from "./shared/services/user/user-information.service";
import { AppConfig } from "./app.config";
import { RequestStatusService } from "./shared/services/request-status/request-status.service";
import { SystemModuleSettingsService } from "./shared/services/system-module-settings.service";
import { ServerNotificationService } from "./shared/services/server-notification/server-notification.service";
import { WebNotificationService } from "./shared/services/web-notification/web-notification.service";
import { Router } from "@angular/router";
import { LocalStorageEnum } from "./shared/services/storage/local-storage-constants";
import { LocalStorageService } from "./shared/services/storage/local-storage.service";
import { SessionStorageEnum } from "./shared/services/storage/session-storage-constants";
import { SessionStorageService } from "./shared/services/storage/session-storage.service";
import { LandingPageService } from "./core/landing-page/shared/services/landing-page.service";
import { AutoUnsubPortal } from "./shared/decorators/autounsub-portal.decorator";
import { Title } from "@angular/platform-browser";
import { AflaCommonService } from "../../../afla-common/src/lib/afla-common.service";
import { AppComponentConstants } from "./app.component.constants";
import { AlertType } from "./shared/models/alert";
let AppComponent = class AppComponent {
    appController;
    authService;
    loginService;
    sessionStorageService;
    windowReference;
    bottomSheet;
    landingPageService;
    userInformationService;
    appConfig;
    requestStatusService;
    systemModuleSettingsService;
    serverMessageService;
    webNotificationService;
    router;
    localStorage;
    changeDetectorRefs;
    titleService;
    aflaCommonService;
    appBaseHref;
    url;
    /*   branding: IBranding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        calciteUIBrand: SharedConstants.DEFAULT_COLOR,
        calciteUIBrandHover: SharedConstants.DEFAULT_DARKER_COLOR,
        calciteUIBrandPress: SharedConstants.DEFAULT_COLOR,
      }; */
    branding = {
        themeMainColor: null,
        themeMainDarkerColor: null,
        themeMainBackgroundColor: null,
        themeMainBorderColor: null,
        themeHeaderBorderColor: null,
        themeActiveColor: null,
        themeActiveAlternateColor: null,
        themeLogoBackgroundColor: null,
        themePrimaryButtonColor: null,
        calciteUIBrand: null,
        calciteUIBrandHover: null,
        calciteUIBrandPress: null,
    };
    mapCenter = [-122.4194, 37.7749];
    basemapType = "satellite";
    mapZoomLevel = 12;
    $isAuthenticated;
    $userInformationFetched;
    showBusyIndicator = false;
    showLandingPage = false;
    showInitialView = false;
    shouldAutoAuthenticateFromExternalLanding = false;
    hasShownExternalLandingUnavailableWarning = false;
    deferredPromptEvent;
    ON_SAME_RELOAD_STRATEGY = AppComponentConstants.ON_SAME_RELOAD_STRATEGY;
    messageReceivedSubscription;
    constructor(appController, authService, loginService, sessionStorageService, windowReference, bottomSheet, landingPageService, userInformationService, appConfig, requestStatusService, systemModuleSettingsService, serverMessageService, webNotificationService, router, localStorage, changeDetectorRefs, titleService, aflaCommonService, appBaseHref, url) {
        this.appController = appController;
        this.authService = authService;
        this.loginService = loginService;
        this.sessionStorageService = sessionStorageService;
        this.windowReference = windowReference;
        this.bottomSheet = bottomSheet;
        this.landingPageService = landingPageService;
        this.userInformationService = userInformationService;
        this.appConfig = appConfig;
        this.requestStatusService = requestStatusService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.serverMessageService = serverMessageService;
        this.webNotificationService = webNotificationService;
        this.router = router;
        this.localStorage = localStorage;
        this.changeDetectorRefs = changeDetectorRefs;
        this.titleService = titleService;
        this.aflaCommonService = aflaCommonService;
        this.appBaseHref = appBaseHref;
        this.url = url;
        this.saveUrl();
        this.$userInformationFetched = this.userInformationService.$userInformationFetched;
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.listenForLandingPageLogin();
        this.startAuthenticationProcess();
        this.setupPwaInstall(windowReference);
    }
    ngOnInit() {
        this.listenForBusySpinnerChanges();
        this.setRouterReloadStrategy();
    }
    saveUrl() {
        const strings = window.location.href.split(window.location.host);
        const url = strings[strings.length - 1];
        if (!url.includes("#id_token=")) {
            this.localStorage.set(LocalStorageEnum.Url, url);
        }
    }
    startAuthenticationProcess() {
        this.shouldAutoAuthenticateFromExternalLanding = false;
        this.loadAppConfig(() => {
            const localStorageIsAuthenticated = this.sessionStorageService.get(SessionStorageEnum.Nonce);
            if (this.handleExternalLanding(localStorageIsAuthenticated)) {
                return;
            }
            if (!localStorageIsAuthenticated) {
                if (this.shouldAutoAuthenticateFromExternalLanding) {
                    this.showLandingPage = false;
                    this.authenticate();
                    return;
                }
                this.showLandingPage = true;
                this.completeInitialViewSetup();
                return;
            }
            else if (this.router.url.includes("/logout")) {
                this.authService.unAuthenticateFrontChannel();
                this.completeInitialViewSetup();
                return;
            }
            else {
                this.showLandingPage = false;
                if (this.authService.checkIfLoggedIn()) {
                    this.authService.configureAuth();
                    this.showLandingPage = false;
                }
                else {
                    this.authenticate();
                }
            }
            this.completeInitialViewSetup();
        });
    }
    loadAppConfig(appConfigLoadedAction) {
        this.appConfig.load().then(() => {
            appConfigLoadedAction();
            if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
                this.branding = AppConfig.settings.projectSettings.styling;
            }
            this.aflaCommonService.setThemeColors(this.branding);
            this.changeDetectorRefs.detectChanges();
        });
    }
    authenticate() {
        this.authService.authenticate().then((result) => {
            this.handleUserLoggedIn();
        });
    }
    setupPwaInstall(windowReference) {
        windowReference.nativeWindow.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            this.deferredPromptEvent = event;
            // TODO: Re-add this
            // const bottomSheetRef = this.bottomSheet.open(PwaInstallBottomSheetComponent);
            // bottomSheetRef.afterDismissed()
            //   .pipe(takeUntil(this.ngUnsubscribe))
            //   .subscribe((result) => {
            //     if (result) {
            //       this.promptInstallPWA();
            //     }
            //   });
        });
    }
    promptInstallPWA() {
        this.deferredPromptEvent.prompt();
    }
    listenForBusySpinnerChanges() {
        this.requestStatusService.$requestBusy.subscribe(value => {
            this.showBusyIndicator = value;
            this.changeDetectorRefs.detectChanges();
        });
    }
    handleUserLoggedIn() {
        this.listenForServerMessages();
    }
    listenForServerMessages() {
        this.messageReceivedSubscription = this.serverMessageService.messageReceived.subscribe((message) => {
            this.webNotificationService.showNotification("Message received", message);
        });
    }
    setRouterReloadStrategy() {
        this.router.onSameUrlNavigation = this.ON_SAME_RELOAD_STRATEGY;
    }
    listenForLandingPageLogin() {
        this.landingPageService.loginButtonClicked.subscribe({
            next: (isLoginButtonClicked) => {
                if (isLoginButtonClicked) {
                    this.authenticate();
                }
            }
        });
    }
    busySpinnerDoubleClick() {
        this.requestStatusService.printBusyIndicators();
    }
    completeInitialViewSetup() {
        this.showInitialView = true;
    }
    handleExternalLanding(localStorageIsAuthenticated) {
        if (!this.isExternalLandingEnabled()) {
            return false;
        }
        if (!this.isApplicationRootPath()) {
            return false;
        }
        if (this.isAuthCallbackInProgress()) {
            return false;
        }
        if (this.shouldBypassExternalLandingForLogin()) {
            this.clearExternalLandingPendingLogin();
            this.removeStartLoginQueryParam();
            this.shouldAutoAuthenticateFromExternalLanding = true;
            return false;
        }
        if (this.isAuthenticated(localStorageIsAuthenticated)) {
            this.clearExternalLandingPendingLogin();
            return false;
        }
        const externalLandingPageUrl = this.getExternalLandingPageUrl();
        if (externalLandingPageUrl) {
            if (this.isCurrentPortalUrl(externalLandingPageUrl)) {
                return false;
            }
            this.markExternalLandingPendingLogin();
            window.location.replace(externalLandingPageUrl);
            return true;
        }
        this.showExternalLandingUnavailableWarningOnce();
        const internalLandingPageUrl = this.getInternalLandingPageUrl();
        if (!internalLandingPageUrl) {
            return false;
        }
        if (this.isCurrentPortalUrl(internalLandingPageUrl)) {
            return false;
        }
        window.location.replace(internalLandingPageUrl);
        return true;
    }
    isExternalLandingEnabled() {
        return AppConfig.settings?.landingPage?.enableExternalLandingPage?.toLowerCase() === "true";
    }
    getExternalLandingPageUrl() {
        const configuredExternalUrl = AppConfig.settings?.landingPage?.externalLandingPageUrl?.trim();
        return this.getValidatedAbsoluteHttpUrl(configuredExternalUrl);
    }
    getInternalLandingPageUrl() {
        const configuredInternalUrl = AppConfig.settings?.ids?.redirectUri?.trim();
        return this.getValidatedAbsoluteHttpUrl(configuredInternalUrl);
    }
    getValidatedAbsoluteHttpUrl(value) {
        if (!value) {
            return "";
        }
        try {
            const parsedUrl = new URL(value);
            const isSupportedProtocol = parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
            return isSupportedProtocol ? value : "";
        }
        catch (error) {
            return "";
        }
    }
    showExternalLandingUnavailableWarningOnce() {
        if (this.hasShownExternalLandingUnavailableWarning) {
            return;
        }
        this.hasShownExternalLandingUnavailableWarning = true;
        this.appController.showMessage(AppComponentConstants.EXTERNAL_LANDING_UNAVAILABLE_WARNING, AlertType.Warning, true);
    }
    isCurrentPortalUrl(value) {
        try {
            const parsedUrl = new URL(value);
            if (parsedUrl.origin !== window.location.origin) {
                return false;
            }
            return this.isPathWithinBaseHref(parsedUrl.pathname);
        }
        catch (error) {
            return false;
        }
    }
    isPathWithinBaseHref(pathName) {
        const normalizedBasePath = this.normalizePathWithoutTrailingSlash(this.getNormalizedBaseHref());
        const normalizedPath = this.normalizePathWithoutTrailingSlash(pathName);
        if (normalizedBasePath === AppComponentConstants.DEFAULT_BASE_HREF) {
            return normalizedPath.startsWith(AppComponentConstants.DEFAULT_BASE_HREF);
        }
        return normalizedPath === normalizedBasePath || normalizedPath.startsWith(`${normalizedBasePath}/`);
    }
    isAuthenticated(localStorageIsAuthenticated) {
        if (localStorageIsAuthenticated) {
            return true;
        }
        return this.authService.checkIfLoggedIn();
    }
    isApplicationRootPath() {
        return this.getCurrentPathWithinBase() === AppComponentConstants.DEFAULT_BASE_HREF;
    }
    getCurrentPathWithinBase() {
        const currentPathName = this.normalizePathWithoutTrailingSlash(window.location.pathname);
        const baseHrefPath = this.normalizePathWithoutTrailingSlash(this.getNormalizedBaseHref());
        if (baseHrefPath === AppComponentConstants.DEFAULT_BASE_HREF) {
            return currentPathName;
        }
        if (currentPathName === baseHrefPath) {
            return AppComponentConstants.DEFAULT_BASE_HREF;
        }
        if (currentPathName.startsWith(`${baseHrefPath}/`)) {
            const pathWithoutBaseHref = currentPathName.substring(baseHrefPath.length);
            return this.normalizePathWithoutTrailingSlash(pathWithoutBaseHref);
        }
        return currentPathName;
    }
    getNormalizedBaseHref() {
        let normalizedBaseHref = this.appBaseHref ? this.appBaseHref.trim() : "";
        if (!normalizedBaseHref || normalizedBaseHref === "./") {
            return AppComponentConstants.DEFAULT_BASE_HREF;
        }
        normalizedBaseHref = this.replaceBackslashes(normalizedBaseHref);
        normalizedBaseHref = this.ensureLeadingSlash(normalizedBaseHref);
        normalizedBaseHref = this.collapseConsecutiveSlashes(normalizedBaseHref);
        normalizedBaseHref = this.ensureTrailingSlash(normalizedBaseHref);
        return normalizedBaseHref;
    }
    normalizePathWithoutTrailingSlash(path) {
        if (!path) {
            return AppComponentConstants.DEFAULT_BASE_HREF;
        }
        let normalizedPath = path.trim();
        if (!normalizedPath || normalizedPath === "./") {
            return AppComponentConstants.DEFAULT_BASE_HREF;
        }
        normalizedPath = this.replaceBackslashes(normalizedPath);
        normalizedPath = this.ensureLeadingSlash(normalizedPath);
        normalizedPath = this.collapseConsecutiveSlashes(normalizedPath);
        normalizedPath = this.removeTrailingSlash(normalizedPath);
        return normalizedPath;
    }
    replaceBackslashes(value) {
        if (!value) {
            return value;
        }
        return value.split("\\").join("/");
    }
    collapseConsecutiveSlashes(value) {
        if (!value) {
            return value;
        }
        let collapsedValue = "";
        let previousCharacterWasSlash = false;
        for (const currentCharacter of value) {
            const currentCharacterIsSlash = currentCharacter === "/";
            if (currentCharacterIsSlash && previousCharacterWasSlash) {
                continue;
            }
            collapsedValue += currentCharacter;
            previousCharacterWasSlash = currentCharacterIsSlash;
        }
        return collapsedValue;
    }
    ensureLeadingSlash(value) {
        if (!value.startsWith("/")) {
            return `/${value}`;
        }
        return value;
    }
    ensureTrailingSlash(value) {
        if (!value.endsWith("/")) {
            return `${value}/`;
        }
        return value;
    }
    removeTrailingSlash(value) {
        if (value.length > 1 && value.endsWith("/")) {
            return value.substring(0, value.length - 1);
        }
        return value;
    }
    isAuthCallbackInProgress() {
        const hasCallbackValuesInHash = this.containsAnyCallbackKey(window.location.hash, AppComponentConstants.HASH_CALLBACK_KEYS);
        const hasCallbackValuesInSearch = this.hasAnyQueryCallbackKey(window.location.search, AppComponentConstants.QUERY_CALLBACK_KEYS);
        return hasCallbackValuesInHash || hasCallbackValuesInSearch;
    }
    containsAnyCallbackKey(currentValue, callbackKeys) {
        if (!currentValue) {
            return false;
        }
        const normalizedValue = currentValue.toLowerCase();
        return callbackKeys.some(callbackKey => normalizedValue.includes(callbackKey.toLowerCase()));
    }
    hasAnyQueryCallbackKey(searchQuery, callbackKeys) {
        if (!searchQuery) {
            return false;
        }
        const searchParams = new URLSearchParams(searchQuery);
        return callbackKeys.some(callbackKey => searchParams.has(callbackKey));
    }
    shouldBypassExternalLandingForLogin() {
        const hasStartLoginQueryParam = this.hasStartLoginQueryParam();
        if (hasStartLoginQueryParam) {
            return true;
        }
        return this.hasExternalLandingPendingLogin();
    }
    hasStartLoginQueryParam() {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(AppComponentConstants.START_LOGIN_QUERY_PARAM) === AppComponentConstants.FLAG_ENABLED_VALUE;
    }
    removeStartLoginQueryParam() {
        const searchParams = new URLSearchParams(window.location.search);
        if (!searchParams.has(AppComponentConstants.START_LOGIN_QUERY_PARAM)) {
            return;
        }
        searchParams.delete(AppComponentConstants.START_LOGIN_QUERY_PARAM);
        const search = searchParams.toString();
        const nextUrl = `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`;
        window.history.replaceState(window.history.state, AppComponentConstants.EMPTY_HISTORY_TITLE, nextUrl);
    }
    markExternalLandingPendingLogin() {
        this.sessionStorageService.getStorage().setItem(AppComponentConstants.EXTERNAL_LANDING_PENDING_LOGIN_KEY, AppComponentConstants.FLAG_ENABLED_VALUE);
    }
    hasExternalLandingPendingLogin() {
        return this.sessionStorageService.getStorage().getItem(AppComponentConstants.EXTERNAL_LANDING_PENDING_LOGIN_KEY) === AppComponentConstants.FLAG_ENABLED_VALUE;
    }
    clearExternalLandingPendingLogin() {
        this.sessionStorageService.getStorage().removeItem(AppComponentConstants.EXTERNAL_LANDING_PENDING_LOGIN_KEY);
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: AuthService },
        { type: LoginService },
        { type: SessionStorageService },
        { type: WindowReference },
        { type: MatBottomSheet },
        { type: LandingPageService },
        { type: UserInformationService },
        { type: AppConfig },
        { type: RequestStatusService },
        { type: SystemModuleSettingsService },
        { type: ServerNotificationService },
        { type: WebNotificationService },
        { type: Router },
        { type: LocalStorageService },
        { type: ChangeDetectorRef },
        { type: Title },
        { type: AflaCommonService },
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: LocationStrategy }
    ];
};
AppComponent = __decorate([
    Component({
        selector: "app-root",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], AppComponent);
export { AppComponent };
